import { Action } from 'redux';
// Import States.
import {
	AppState,
	PossibleProducerAgentsState,
	getInitialPossibleProducerAgentsState,
} from '@app/redux/states';
// Import Actions.
import {
	LoadPossibleProducerAgentsAction,
	PossibleProducerAgentAction,
} from '@app/redux/actions';
// Import api models.
import {
	PossibleProducerAgent,
} from '@app/models/api';


/**
 * This handles initializing the state.
 * @param state
 * @param action
 */
let initializeState = (state: AppState, action: PossibleProducerAgentAction): AppState => {
	let newState: AppState = { ...state };
	// Initialize the state.
	if (newState.possibleProducerAgents[action.producerAgencyId] === undefined) {
		newState.possibleProducerAgents[action.producerAgencyId] = getInitialPossibleProducerAgentsState();
	}
	else {
		newState.possibleProducerAgents[action.producerAgencyId] = { ...newState.possibleProducerAgents[action.producerAgencyId] }
	}

	return newState;
}

/**
 * Query the state.
 * @param state
 * @param action
 */
let queryPossibleProducerAgentsState = (state: AppState, action: PossibleProducerAgentAction): PossibleProducerAgentsState => {
	return state.possibleProducerAgents[action.producerAgencyId];
}

// Load Possible Producer Agents Reducer.

let LoadPossibleProducerAgentsReducer = (state: AppState, action: Action): AppState => {
	let loadPossibleProducerAgentsAction: LoadPossibleProducerAgentsAction = action as LoadPossibleProducerAgentsAction;
	let possibleProducerAgents: PossibleProducerAgent[] = loadPossibleProducerAgentsAction.possibleProducerAgents;

	// Create copy of the of app state.
	let newState: AppState = initializeState(state, loadPossibleProducerAgentsAction);

	// Query the state.
	let possibleProducerAgentsState: PossibleProducerAgentsState = queryPossibleProducerAgentsState(newState, loadPossibleProducerAgentsAction);

	possibleProducerAgentsState.possibleProducerAgents = possibleProducerAgents;
	possibleProducerAgentsState.arePossibleProducerAgentsLoaded = true;

	return newState;
}

// Export reducers.
export {
	LoadPossibleProducerAgentsReducer,
};

// Export initializers.
export {
	initializeState
}

// Export queries.
export {
	queryPossibleProducerAgentsState
};